import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.date.to-string.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import "./index.scss";
import { assert } from "@/common/assert";
import jqueryDataUtil from "@/common/jqueryDataUtil";
import { loadScript } from "@/pages/base/loadScript";

var makeSocialShareHtml = function makeSocialShareHtml(data) {
  return "\n<div class=\"social-share\">\n    <div class=\"social-share__header\"></div>\n    <div class=\"bdsharebuttonbox social-share__content bdshare-button-style0-16\" \n        data-url=\"" + data.url + "\" \n        data-desc=\"" + data.desc + "\" \n        data-pics=\"" + data.picUrls + "\" \n        data-title=\"" + data.title + "\">\n        <a href=\"#\" class=\"bds_weixin\" data-cmd=\"weixin\" title=\"\u53D1\u81F3\u5FAE\u4FE1\">\u53D1\u81F3\u5FAE\u4FE1</a>\n        <a href=\"#\" class=\"bds_tsina\" data-cmd=\"tsina\" title=\"\u53D1\u81F3\u5FAE\u535A\">\u53D1\u81F3\u5FAE\u535A</a>\n        <a href=\"#\" class=\"bds_qzone\" data-cmd=\"qzone\" title=\"QQ\u7A7A\u95F4\">QQ\u7A7A\u95F4</a>\n        <a href=\"#\" class=\"bds_more\" data-cmd=\"more\" title=\"\u66F4\u591A\">\u66F4\u591A</a>\n    </div>\n</div>\n";
};

var $socialShare = $(".js-forward");

if ($socialShare.length) {
  $socialShare.each(function (index, el) {
    var $el = $(el);
    var shareUrl = jqueryDataUtil.requiredString($el, "url");
    var shareTitle = jqueryDataUtil.requiredString($el, "title");
    var shareDesc = jqueryDataUtil.optionalString($el, "desc");
    var sharePicUrl = jqueryDataUtil.optionalString($el, "pics");
    var html = makeSocialShareHtml({
      url: shareUrl,
      title: shareTitle,
      desc: shareDesc,
      picUrls: sharePicUrl
    });
    $(html).appendTo(el);
  });
  import("@/pages/vendors/vendor.hoverIntent").then(function (_a) {
    var createHoverIntent = _a.createHoverIntent;
    createHoverIntent($socialShare, {
      timeout: 200,
      over: function over() {
        var el = this;
        assert(el.tagName, "this should be a tag");
        var $el = $(el);
        $el.find(".social-share").show();
      },
      out: function out() {
        var el = this;
        assert(el.tagName, "this should be a tag");
        var $el = $(el); // eslint-disable-next-line fht-eslint-rules/restricted-jquery-methods-error

        $el.find(".social-share").hide();
      }
    });
  });
}

var shareurl = "";
var sharedesc = "";
var sharepic = "";
var sharetitle = "";
$(document.body).on("mouseover", ".bdsharebuttonbox a", function () {
  var $p = $(this).parents(".bdsharebuttonbox");
  assert($p.length, "no $p");
  shareurl = jqueryDataUtil.requiredString($p, "url");
  sharedesc = jqueryDataUtil.optionalString($p, "desc");
  sharepic = jqueryDataUtil.optionalString($p, "pics");
  sharetitle = jqueryDataUtil.requiredString($p, "title");
});

function SetShare(cmd, config) {
  if (shareurl) {
    config.bdUrl = shareurl;
  }

  if (sharedesc) {
    config.bdDesc = sharedesc;
  }

  if (sharepic) {
    config.bdPic = sharepic;
  }

  if (sharetitle) {
    config.bdText = sharetitle;
  }

  return config;
} //eslint-disable-next-line fht-eslint-rules/no-property-assignment-to-window


window._bd_share_config = {
  common: {
    onBeforeClick: SetShare,
    bdSnsKey: {},
    bdMini: "2",
    bdMiniList: false,
    bdStyle: "0",
    bdSize: "16"
  },
  share: {}
};
var socialShareScriptSrc = "/static/api/js/share.js?v=89860593.js?cdnversion=" + ~(-new Date() / 36e5);

(function () {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , loadScript(socialShareScriptSrc)];

        case 1:
          _a.sent(); //eslint-disable-next-line fht-eslint-rules/no-property-assignment-to-window


          window._bd_share_main.init();

          return [2
          /*return*/
          ];
      }
    });
  });
})();